module.exports = __webpack_public_path__ + "img/power.43c8082b.svg";